import axios from "axios";
import AppContext from "context/AppContext";
import React, { useContext, useState } from "react";
import { FaClock } from 'react-icons/fa';
import Swal from "sweetalert2";

const ExBookVisitRequest = ({ property_id, seller_id }) => {
  const [bookingDate, setBookingDate] = useState("");
  const [bookingTime, setBookingTime] = useState("");
  const [status, setStatus] = useState('pending');
  const { baseUrl, loggedInBuyer: contextBuyer ,authToken} = useContext(AppContext);
  const loggedInBuyer = contextBuyer || JSON.parse(localStorage.getItem('loggedInBuyer'));

  const [showBookingPanel, setShowBookingPanel] = useState(false);

  const TIME_SLOTS = [
    "10:00 AM", "11:00 AM", "12:00 PM", "01:00 PM",
    "02:00 PM", "03:00 PM", "04:00 PM", "05:00 PM"
  ];

  const createVisitRequest = () => {
      console.log("SELLER ID RECEIVED:", seller_id);

    const formData = new FormData();
    formData.append("exbuyer_id", loggedInBuyer?.id);
    formData.append("exseller_id", seller_id);
    formData.append("exproperty_id", property_id);
    formData.append("bookingDate", bookingDate);
    formData.append("bookingTime", bookingTime);
    formData.append("status", status);

    axios
      .post(`${baseUrl}/buyer/visitrequest/createVisitRequest`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${authToken}`
        },
      })
      .then((response) => {
        console.log('Visit Requests:', response.data);

        if (response.data.success) {
          Swal.fire({
            title: "Congragulation",
            text: "Visit Request Sent Successfully",
            icon: "success"
          });
        } else {
          console.log(response.data.error);
          Swal.fire({
            title: "Error",
            text: response.data.error || "Something went wrong",
            icon: "error"
          });
        }
        setShowBookingPanel(false);
      })
      .catch((error) => {
        console.log("Error creating visit request:", error);

      });
  };

  return (
    <React.Fragment>
      <div className="propdetail-form-group">
        <label className="propdetail-form-label">Booking Date *</label>
        <input
          type="date"
          className="propdetail-form-input"
          min={new Date().toISOString().split("T")[0]}
          value={bookingDate}
          onChange={(e) => setBookingDate(e.target.value)}
        />
      </div>

      {/* Time Slots */}
      <div className="propdetail-time-group full">
        <label className="propdetail-form-lbl">
          <FaClock style={{ marginRight: 4 }} />
          Booking Time *
        </label>
        <div className="propdetail-time-chips">
          {TIME_SLOTS.map((t) => (
            <button
              key={t}
              className={`propdetail-time-chip ${bookingTime === t ? "on" : ""}`}
              onClick={() => setBookingTime(t)}
              type="button"
            >
              {t}
            </button>
          ))}
        </div>
      </div>

      {/* Book Now Button */}
      <button
        type="button"
        onClick={createVisitRequest}
        className="propdetail-book-btn Poppins-Bold"
      >
        📧 Book Now
      </button>
    </React.Fragment>
  );
};

export default ExBookVisitRequest;
